import React from 'react';

// import profilePic from './profile-pic.jpg'
import { Column, Row } from './Skeleton';
import EmailSignupCTA from './EmailSignupCTA';

class Bio extends React.Component {
  render() {
    return (
      <div>
        <p>
          {/*<img src={profilePic} alt={`Kyle Mathews`} />*/}
          I'm <strong>Henry Moulton</strong>, a software design and
          development freelancer living in
          {' '}<strong>London, UK</strong>.{' '}
        </p>
        <p>
          {/*I like*/}
          {/*{' '}<a href="https://notes-4655a.firebaseapp.com">*/}
          {/*learning new technologies*/}
          {/*</a>*/}
          {/*{' '}and making little products like*/}
          {/*<a href="https://state-1502899811094.firebaseapp.com*/}
{/*">      my Tech News aggregator*/}
          {/*</a>*/}
          {/*.*/}
          {' '}My portfolio will be online soon.
        </p>
        <Row>
          <Column xs={'12'}>
            <p>
              I'm on
              {' '}<a href="https://twitter.com/henrymoulton">Twitter</a> and
              {' '}
              <a href="https://www.linkedin.com/in/henrymoulton/">
                LinkedIn
              </a>, and for years I've been collecting bits of the internet I
              found interesting on
              {' '}<a href="https://henrymoulton.tumblr.com">Tumblr</a>.
            </p>
          </Column>
          <p>
            You can also signup to have every post I write sent straight to your
            inbox:
          </p>
          <EmailSignupCTA />
        </Row>

      </div>
    );
  }
}

export default Bio;



// WEBPACK FOOTER //
// ./src/components/Bio.js